<ukg-card has-border class="panel-container">
  <div class="header-section">
    <div class="header-top-section">
      <span data-automation="alerts_and_notifications_title" class="header-title">{{'ALERTS.PSG_WIDGET_TITLE' | translate }}</span>
      <ukg-badge data-automation="alerts_and_notifications_page_title_tooltip" color="important"
        value="{{numUnAcknowledged}}" class="notification-badge"></ukg-badge>
    </div>
    <div data-automation="alerts_and_notifications_info_home" class="header-desp">{{'ALERTS.CURRENT_ALERTS_INFORMATION'
      | translate }}</div>
  </div>
  <ukg-card-content>
    <ukg-list>
      <ukg-list-item>
        <div *ngFor="let counts of alertCounts">
          <div class="alerts-component-row flex-row" (click)="onAlertsClick(counts.category)"
            data-automation="alerts_and_notifications_page_link">
            <ukg-icon *ngIf="counts.hasUnAcknowledged" class="alerts-icon" name="warning" color="important"
              data-automation="alert_icon_btn"></ukg-icon>
            <ukg-label type="primary" class="alert-label" *ngIf="counts.hasUnAcknowledged"
              data-automation="contains_alerts_and_notifications_label">{{ 'ALERTS.COUNT_CATEGORY' | translate: { unacknowledgedCount: counts.unAcknowledged, category: counts.category | enum: 'CustomerNotificationCategory' } }} </ukg-label>
            <ukg-label type="primary" *ngIf="!counts.hasUnAcknowledged"
              data-automation="no_alerts_and_notifications_label">{{ categoryI18nKey | translate: { category:
              counts.category | enum: 'CustomerNotificationCategory' } }}</ukg-label>
          </div>
        </div>
        <ukg-label *ngIf="showMessageForNoAlerts" class="no-Alert" type="section" data-automation="alerts_no_data_label"
          translate>ALERTS.NO_CURRENT_ALERTS</ukg-label>
      </ukg-list-item>
    </ukg-list>
  </ukg-card-content>
</ukg-card>